import { handleActions } from "redux-actions";

export default handleActions(
  {
    SIDEBAR: {
      OPEN: () => ({
        isSidebarOpen: true,
      }),
      CLOSE: () => ({
        isSidebarOpen: false,
      }),
    },
  },
  {},
  { namespace: "_" }
);
